import { gql } from "@apollo/client";

const importOneononeNotesMutation = gql`
  mutation importOneononeNotesMutation(
    $reportUserId: Int!
    $timezone: String
    $meetings: [ImportOneononeMeetingInput!]!
  ) {
    importOneononeNotes(
      reportUserId: $reportUserId
      timezone: $timezone
      meetings: $meetings
    ) {
      meetings {
        id
        meetingGroupId
        startDatetime
      }
      skippedDates
    }
  }
`;

export default importOneononeNotesMutation;
